import React from 'react';
import { useInfluencerStore } from '@/stores/influencerStore';

export const TierProgress: React.FC = () => {
  const { tier } = useInfluencerStore();

  return (
    <div className="space-y-6">
      <div className="bg-white p-6 rounded-lg shadow">
        <h3 className="text-lg font-medium mb-4">Tier Progress</h3>
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <span className="text-sm font-medium text-gray-700">Current Tier: {tier.current}</span>
            <span className="text-sm text-gray-500">
              Progress: {tier.progress.toFixed(1)}%
            </span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-3">
            <div 
              className="bg-blue-600 h-3 rounded-full transition-all duration-300"
              style={{ width: `${tier.progress}%` }}
            />
          </div>
          <p className="text-sm text-gray-600">
            {tier.nextTierRequirement} signups required for next tier
          </p>
        </div>
      </div>
    </div>
  );
}; 